export default __webpack_public_path__ + "static/media/HOME.869af62c.png";